/* eslint-disable */
import Backbone from 'backbone';
import Cookies from 'js-cookie';
import template from './template.html';

class CookieConsentView extends Backbone.View {
    constructor(options) {
        super(options);
        this.cookieName = 'cookieConsent';
        this.cookieValue = 'accepted';
        this.cookieExpiryDays = 365;
        this.render();
        this.initPopup();
    }

    getCookieDomain() {
        const hostname = window.location.hostname;
        if (hostname === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
            return '';
        }
        return `.${hostname}`;
    }

    getPossibleCookieDomains() {
        const hostname = window.location.hostname;
        if (hostname === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
            return [];
        }
        return [hostname, `.${hostname}`];
    }

    render() {
        this.$el.html(template());
        return this;
    }

    initPopup() {
        this.$cookieConsent = this.$('#cookieConsent');

        if (this.shouldSkipConsent()) {
            return;
        }

        if (this.hasConsent()) {
            this.migrateCookie();
            return;
        }

        this.showConsentBanner();
        this.bindEvents();
    }

    hasConsent() {
        if (Cookies.get(this.cookieName) === this.cookieValue) {
            return true;
        }

        const possibleDomains = this.getPossibleCookieDomains();
        for (const domain of possibleDomains) {
            try {
                if (Cookies.get(this.cookieName, { domain }) === this.cookieValue) {
                    return true;
                }
            } catch (e) {
                console.warn('Cannot check cookies on domain', domain, e);
            }
        }

        return false;
    }

    migrateCookie() {
        this.handleAccept();
    }

    shouldSkipConsent() {
        return window.self !== window.top;
    }

    showConsentBanner() {
        this.$cookieConsent.show();
    }

    bindEvents() {
        this.$cookieConsent.find('.cookieConsentPopup__accept-btn, .cookieConsentAccept').on('click', this.handleAccept.bind(this));
        this.$cookieConsent.find('a').on('click', this.handleLinkClick.bind(this));
    }

    handleAccept() {
        const cookieDomain = this.getCookieDomain();
        const options = {
            expires: this.cookieExpiryDays,
            path: '/',
            sameSite: 'Lax',
            secure: window.location.protocol === 'https:'
        };

        if (cookieDomain) {
            options.domain = cookieDomain;
        }

        Cookies.set(this.cookieName, this.cookieValue, options);
        this.$cookieConsent.hide();
    }

    handleLinkClick(e) {
        e.preventDefault();
        window.open(e.currentTarget.href, '_blank', 'noopener,noreferrer');
    }
}

export default CookieConsentView;